import React from "react";
import { Datagrid, EditButton, List, TextField } from "react-admin";

import { DatagridWithBlockDeleteProps } from "../../../components/_helpers/props/DatagridProps";
import { stylesForColorInheritInList } from "../../../components/_helpers/useStyles";
import { CopyField } from "../../../components/fields/CopyField";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { ExternalTerminalsFilter } from "./ListFilters";

const defaultSort = { field: "name", order: "ASC" };

export const ExternalTerminalsList = (props) => {
	const classes = stylesForColorInheritInList();

	return (
		<List
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<ExternalTerminalsFilter />}
			classes={classes}
		>
			<ScrollingWrapper>
				<Datagrid {...DatagridWithBlockDeleteProps}>
					<TextField source="name" />
					<CopyField
						source="api_url"
						style={{
							width: "300px",
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							display: "inline-block",
						}}
					/>
					<CopyField
						sortable={false}
						source="guid"
						style={{
							width: "300px",
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							display: "inline-block",
						}}
					/>
					<CopyField
						sortable={false}
						source="api_key"
						style={{
							width: "300px",
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							display: "inline-block",
						}}
					/>
					<EditButton />
				</Datagrid>
			</ScrollingWrapper>
		</List>
	);
};
